export default __webpack_public_path__ + "static/media/createNewKahshIcon2.3cb6f88d.png";